import { useEffect, useRef } from 'react';
import { useAuth } from '../../contexts';
import { authService } from '../../services/auth';

/**
 * Componente que valida periodicamente a autenticação do usuário
 * Verifica se o token ainda é válido e força logout se necessário
 */
export const AuthValidator = () => {
  const { isAuthenticated, logout } = useAuth();
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    // Só validar se estiver autenticado
    if (!isAuthenticated) {
      return;
    }

    // Função para validar token
    const validateToken = async () => {
      try {
        const token = authService.getToken();
        
        // Se não há token mas está marcado como autenticado, fazer logout
        if (!token) {
          console.warn('Token não encontrado. Fazendo logout...');
          await logout();
          return;
        }

        // Tentar buscar usuário para validar token
        await authService.getCurrentUser();
      } catch (error: any) {
        // Se erro 401, token inválido - fazer logout
        if (error.response?.status === 401) {
          console.warn('Token inválido detectado. Fazendo logout...');
          await logout();
        }
      }
    };

    // Validar imediatamente ao montar
    validateToken();

    // Validar a cada 5 minutos (300000ms)
    intervalRef.current = setInterval(validateToken, 300000);

    // Limpar intervalo ao desmontar
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isAuthenticated, logout]);

  // Este componente não renderiza nada
  return null;
};
